import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import EditorDialogShell from 'src/common/components/modals/EditorDialogShell';
import { IBaseTrackMap, ITrackData, ITrackMap } from 'src/interfaces/TrackMap';
import TrackMapEditorForm from 'src/pages/Dashboard/System/TrackMaps/forms/TrackMapEditorForm';
import { DialogProps } from '@mui/material/Dialog';

interface Props extends Omit<DialogProps, 'title'> {
  handleClose: () => void;
  handleSave: (
    editedTrackMap: ITrackData & IBaseTrackMap,
    id?: string,
    onSuccess?: () => Promise<void>,
  ) => Promise<void>;
  selectedTrackMap?: ITrackMap;
  isSaving?: boolean;
}

const TrackMapEditorModal = ({
  id,
  open,
  handleClose,
  handleSave,
  selectedTrackMap,
  isSaving,
}: Props) => {
  const [isBusy, setIsBusy] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) {
      setIsBusy(false);
    }
  }, [open]);

  const title = selectedTrackMap
    ? t('system.trackMaps.editTrackMapModalTitle', { name: `${selectedTrackMap.name}` })
    : t('system.trackMaps.addTrackMapModalTitle');

  return (
    <EditorDialogShell
      id={id ?? 'track-map-editor'}
      open={open}
      onClose={handleClose}
      title={title}
      maxWidth="md"
      isLoading={isBusy}
    >
      <TrackMapEditorForm
        handleSave={handleSave}
        handleClose={handleClose}
        selectedTrackMap={selectedTrackMap}
        isSaving={isSaving}
        onBusyChange={setIsBusy}
      />
    </EditorDialogShell>
  );
};

export default TrackMapEditorModal;
